export default __webpack_public_path__ + "static/media/down-arrow.0f1d284f.svg";